<template>
  <div class="app-body">
    <v-row>
      <v-col cols="12" sm="12">
        <v-card>
          <div class="card-body1">
            <v-img src="@/assets/cover2.jpg" class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
              <!-- <v-card-title v-text="card.title"></v-card-title> -->
              <div class="py-4 px-3 text-white">
                <h6>مرحـــبا بــك </h6>


                <h2 v-if="user.userTypeId == 1001">د. {{ user.doctorName }}</h2>
                <h2 v-if="user.userTypeId == 1002">{{ user.employeeName }}</h2>
                <h4> عدد مواعيــد اليوم</h4>
                <div class="mt-4 d-flex gap-3">
                  <div class="d-flex align-items-center">
                    <div class="icon-box lg bg-arctic rounded-3 me-3">
                      <v-icon large color="white">mdi-account-badge</v-icon>
                    </div>


                    <div class="d-flex flex-column">
                      <h2 class="m-0 lh-1">{{ todayStatistics.appointmentsToday }}</h2>
                      <p class="m-0">المرضي </p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="icon-box lg bg-lime rounded-3 me-3">
                      <v-icon large color="white">mdi-account-sync</v-icon>
                    </div>
                    <div class="d-flex flex-column">
                      <h2 class="m-0 lh-1">{{ todayStatistics.reviewToday }}</h2>
                      <p class="m-0">المرجعين</p>
                    </div>
                  </div>

                </div>
              </div>
            </v-img>

          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Row ends -->
    <!-- Row starts -->
    <v-row>
      <v-col cols="12" lg="4" sm="6" v-for="(item, i) in statistics" :key="i">
        <v-card class="mb-3">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="outer-circle">
                <div class="inside-bored bg-success-subtle">
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </div>
              </div>
              <div class="d-flex flex-column mr-3">
                <h2 class="lh-1">{{ item.value }}</h2>
                <p class="m-0">{{ item.label }}</p>
              </div>
            </div>
            <!-- <v-card-actions style="justify-content: end;">
         
              <div >
                <v-btn clorzz="text-primary" outline text>
                <span>عرض التفاصيل</span>
              </v-btn>
             </div>
            </v-card-actions>  -->
          </div>
        </v-card>
      </v-col>

    </v-row>
    <!-- Row ends -->
    <salesByMonth v-if="$hasPermission(1001)"/>
     <appointmentsByDoctor v-if="$hasPermission(1002)"/>
    <!-- <v-card class="my-4 py-4">

      <v-card-text class="py-0">
        <ChartLayout title="التحاليل حسب النتيجة">
          <LineChart :chart-data="appointmentsByDoctor" :height="150" />
        </ChartLayout>
      </v-card-text>
      <v-row class="mx-0 pa-4" justify="center" align="center">
        <div class="h5"> المواعيد الشهرية </div>
      </v-row>
    </v-card> -->
    <!-- <v-card class="my-4 py-4">

      <v-card-text class="py-0">
        <BarChart :chart-data="salesByMonth" :height="250" />
      </v-card-text>
      <v-row class="mx-0 pa-4" justify="center" align="center">
        <div class="h5"> المبيعات الشهرية </div>
      </v-row>
    </v-card> -->
  </div>
</template>
<script>
import appointmentsByDoctor from "./appointmentsByDoctor/Index.vue";
import salesByMonth from "./salesByMonth/Index.vue";
export default {
  components: {
    //  BasicStatistic,
    //  BarChart,
    //  LineChart,
    //  ChartLayout,
    appointmentsByDoctor,
    salesByMonth,
  },
  created() {
    this.$store.dispatch("dashboard/getStatistics")
      .then((res) => {
        this.todayStatistics = res.todayStatistics;// new { appointmentsToday, reviewToday };
        this.statistics[0].value = res.statistics.patients;//new{ patients, appointments , reviews};
        this.statistics[1].value = res.statistics.appointments;//new{ patients, appointments , reviews};
        this.statistics[2].value = res.statistics.reviews;//new{ patients, appointments , reviews};
      });

  },
  data() {
    return {
      todayStatistics: {
        appointmentsToday: 0,
        reviewToday: 0,
      },
      statistics: [
        {
          icon: "mdi-account-multiple",
          value: 0,
          color: "primary",
          label: "اجمالى الحالات",
        },
        {
          icon: "mdi-calendar-multiple",
          value: 0,
          color: "blue",

          label: "اجمالى المواعيد",
        },
        {
          icon: "mdi-file-restore-outline",
          value: 0,
          color: "blue-grey",

          label: "اجمالى المراجعات",
        },
      ]
    }
  },
  computed: {
    user() {
      return this.$store.state.security.user;
      // return this.$store.state.auth.user.fullName;
    },
  }
}
</script>
<style scoped>
/* card */
.inside-bored {
  border-radius: 2em !important;
  width: 3rem;
  height: 3rem;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  box-shadow: inset 1.5px 1.5px 0px rgba(255, 255, 255, .25), inset -1.5px -1.5px 0px rgba(0, 0, 0, .1);

}

.border-primary {
  --bs-border-opacity: 1;
  border: #039ce0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
  /* color: var(--bs-card-color); */
}

.card-body1 {
  flex: 1 1 auto;
  padding: .10rem .10rem;
  background: linear-gradient(277deg, #bdbdbd, #1e1e1e00);
  /* color: var(--bs-card-color); */
}

.outer-circle {
  border-radius: 50% !important;
  padding: .8rem !important;
  margin-right: 1rem !important;

  --bs-border-opacity: 1;

  border: 1px solid #dde2ee;
}

.border-success {
  border-color: #039ce0 !important;
}

.border {
  border: 1px solid #dde2ee;
}

.icon-box.md {
  width: 3rem;
  height: 3rem;
}

.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.text-success {
  color: 039ce0 !important;
}

.box-shadow,
.avatar-box,
.header-actions .header-icon,
.toggle-sidebar,
.pin-sidebar,
.icon-box,
.modal-content,
.btn {
  box-shadow: inset 1.5px 1.5px 0px rgba(255, 255, 255, .25), inset -1.5px -1.5px 0px rgba(0, 0, 0, .1);
}

.bg-success-subtle {
  background-color: 039ce0 !important;
}

/* icon */
.icon-box.lg {
  width: 4rem;
  height: 4rem;
}

.bg-arctic {
  background: #1ec5f9;
}

.bg-lime {
  background: #79d874;
}

.bg-peach {
  background: #fea95f;
}

.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.box-shadow,
.avatar-box,
.header-actions .header-icon,
.toggle-sidebar,
.pin-sidebar,
.icon-box,
.modal-content,
.btn {
  box-shadow: inset 1.5px 1.5px 0px rgba(255, 255, 255, .25), inset -1.5px -1.5px 0px rgba(0, 0, 0, .1);
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.me-3 {
  margin-right: 1rem !important;
}

/*  */
.apexcharts-legend {
  display: flex;
  overflow: auto;
  padding: 0 10px;
}

.apexcharts-legend.apx-legend-position-bottom,
.apexcharts-legend.apx-legend-position-top {
  flex-wrap: wrap
}

.apexcharts-legend.apx-legend-position-right,
.apexcharts-legend.apx-legend-position-left {
  flex-direction: column;
  bottom: 0;
}

.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-left,
.apexcharts-legend.apx-legend-position-right,
.apexcharts-legend.apx-legend-position-left {
  justify-content: flex-start;
}

.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
  justify-content: center;
}

.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
  justify-content: flex-end;
}

.apexcharts-legend-series {
  cursor: pointer;
  line-height: normal;
}

.apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series,
.apexcharts-legend.apx-legend-position-top .apexcharts-legend-series {
  display: flex;
  align-items: center;
}

.apexcharts-legend-text {
  position: relative;
  font-size: 14px;
}

.apexcharts-legend-text *,
.apexcharts-legend-marker * {
  pointer-events: none;
}

.apexcharts-legend-marker {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-right: 3px;
  border-style: solid;
}

.apexcharts-legend.apexcharts-align-right .apexcharts-legend-series,
.apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
  display: inline-block;
}

.apexcharts-legend-series.apexcharts-no-click {
  cursor: auto;
}

.apexcharts-legend .apexcharts-hidden-zero-series,
.apexcharts-legend .apexcharts-hidden-null-series {
  display: none !important;
}

.apexcharts-inactive-legend {
  opacity: 0.45;
}
</style>